import { render, staticRenderFns } from "./EditWheatReceiveModal.vue?vue&type=template&id=b2388a68&"
import script from "./EditWheatReceiveModal.vue?vue&type=script&lang=js&"
export * from "./EditWheatReceiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports